import { IWebhookAttempt } from '@/types';
import { getUrl } from '@/utils/api';

function useWebhooks() {
  const query = getUrl(`v1/webhooks`);
  return {
    ...query,
    data: query.data as IWebhookAttempt[],
  };
}

export default useWebhooks;
